export enum INSIGHTS_DESK_TEAM {
  US = 'US',
  APAC = 'APAC',
  EMEA = 'EMEA',
}

export enum PROJECT_TABLE_COLUMN_TITLE {
  PROJECT_CODE = 'Project Code',
  TITLE = 'Title',
  STATUS = 'Status',
  TEAM = 'Team',
  COMPANY = 'Company',
  TID_POC = 'TID POC',
  REQUESTED_N = 'Requested N',
  COMPLETED_N = 'Completed N',
  PERFORMANCE_PERCENTAGE = 'Performance %',
  LAUNCH = 'Launch',
  CLIENT_POC = 'Client POC',
  ACTIONS = 'Actions',
}

export enum PROJECT_TABLE_COLUMN_KEY {
  PROJECT_CODE = 'projectCode',
  TITLE = 'title',
  STATUS = 'status',
  INSIGHTS_DESK_TEAM = 'insightsDeskTeam',
  COMPANY = 'company',
  TID_POC = 'tidPoc',
  REQUESTED_CALLS = 'requestedCalls',
  COMPLETED_N = 'completedN',
  PERFORMANCE_PERCENTAGE = 'performancePercentage',
  CREATED_AT = 'createdAt',
  CLIENT_POC = 'clientPoc',
  ACTIONS = 'actions',
}

export enum PROJECT_ROLE_TITLE {
  CLIENT = 'client',
  OWNER = 'owner',
}

export const INSIGHTS_DESK_TEAM_OPTIONS = Object.values(INSIGHTS_DESK_TEAM).map((team) => ({
  label: team,
  value: team,
}));
